import { PhoneCall } from "lucide-react";
import { useTranslation } from "react-i18next";

const NUMBERS = [
  "0422-799-4880",
  "0800-836-2567",
  "0212-332-1264",
  "0212-332-1234",
  "911",
  "(0212) 993.25.41 / 992.89.80 / 992.89.90 / 991.79.40",
  "(0212) 993.69.11 / 993.69.91 / 993.13.10 / 993.33.67",
  "(0212) 545.45.45 / 545.46.55 / 577.92.09",
];

function Content({ t }) {
  const descs = t("marquee.descs", { returnObjects: true });
  return (
    <span className="inline-flex items-center pr-12 align-middle">
      <span className="font-extrabold uppercase tracking-wide mr-6">
        {t("marquee.title")}
      </span>
      {NUMBERS.map((num, i) => (
        <span key={i} className="inline-flex items-center mr-6">
          <span className="font-bold text-amber-200">{num}</span>
          <span className="mx-2 text-white/80">·</span>
          <span className="text-white/90">{descs[i]}</span>
        </span>
      ))}
    </span>
  );
}

// Franja roja fija tipo ticker de noticias para la página principal.
export function EmergencyMarquee() {
  const { t } = useTranslation();
  return (
    <div data-testid="emergency-marquee"
      className="fixed top-0 left-0 right-0 z-40 h-9 bg-red-600 text-white flex items-stretch overflow-hidden shadow-md">
      <div className="flex items-center gap-1.5 bg-red-700 px-3 shrink-0 font-bold text-[11px] uppercase tracking-wider">
        <PhoneCall className="w-3.5 h-3.5 animate-pulse" /> {t("marquee.badge")}
      </div>
      <div className="relative flex-1 overflow-hidden flex items-center">
        <div className="emergency-marquee text-xs sm:text-sm">
          <Content t={t} />
          <Content t={t} aria-hidden="true" />
        </div>
      </div>
    </div>
  );
}
